<app-adminav></app-adminav>
<div class="container">
    <div class="col-lg-12 mt-5">
        <h4>Listado de Categorías Torreón Market</h4>
        <hr>
        <table class="table mt-3 animated fadeIn faster">
            <thead class="thead-dark">
                <tr>
                    <th>Categoría</th>
                    <th>Estado</th>
                    <th>Orden</th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody class="text-left">
                <tr *ngFor="let item of categorias">
                    <td>{{item.portada}}</td>
                    <td><b>{{item.estado}}</b></td>
                    <td><b>{{item.orden}}</b></td>
                    <td>
                        <button *ngIf="item.estado == 'Activado'" class="btn btn-dark mr-1" title="Desactivar" (click)="desactivaCategoria(item.id)">
                            <i class="fa fa-power-off"></i>
                        </button>
                        <button *ngIf="item.estado == 'Desactivado'" class="btn btn-success mr-1" title="Activar" (click)="activaCategoria(item.id)">
                            <i class="fa fa-power-off"></i>
                        </button>
                        <button class="btn btn-primary" title="Cambiar orden" (click)="dataCat(item.id)" data-toggle="modal" data-target="#ordenCat">
                            <i class="fa fa-list-ol"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="ordenCat" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Modificar el orden de la categoría:</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <h5>Ingrese el orden que corresponde:</h5>
                <input type="number" min="1" class="form-control" placeholder="Ingrese en número correspondiente" (change)="newOrderCat($event.target.value)">
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                <button type="button" class="btn btn-primary" (click)="actualizarOrden()" data-dismiss="modal">Actualizar</button>
            </div>
        </div>
    </div>
</div>